<a
  class="card p-3 cursor-pointer text-decoration-none"
  *ngIf="booking"
  [routerLink]="['/home/bookings/summary', booking.bookingId]"
>
  <div class="row">
    <div class="col-8">
      <h3 class="fs-5 fw-bold">{{ booking.test.name }}</h3>
      <p *ngIf="timeSlot">
        <span
          >{{
            'booking.default.overviewCard.format.dayOfWeek'
              | translate
                : {
                    timeSlot:
                      timeSlot | localizedDate: 'EEEE'
                  }
          }}<strong>{{
            'booking.default.overviewCard.format.date'
              | translate
                : {
                    timeSlot:
                      timeSlot | localizedDate: 'mediumDate'
                  }
          }}</strong>
        </span>
        <ng-container *ngIf="examEvent">
          <br />
          <span>{{
            'booking.default.overviewCard.format.area'
              | translate: { testarea: examEvent.testarea }
          }}</span>
        </ng-container>
        <span class="time">{{
          'booking.default.overviewCard.format.time'
            | translate
              : {
                  timeSlot:
                    timeSlot | localizedDate: 'shortTime'
                }
        }}</span>
      </p>
      <p *ngIf="!timeSlot">
        {{ 'testevent.deleted.part-1' | translate }}
        <br/>
        {{ 'testevent.deleted.part-2' | translate }}
      </p>
        <div 
          *ngIf="!booking.deleted"
          class="border-start border-5 ps-2"
          [class.border-success]="booking.status === 'paid'"
          [class.border-warning]="booking.status === 'canceled' || (booking.status === 'open' && (booking.paymentExpectedUntil || !booking.requestedPayment))"
          [class.border-danger]="booking.deleted || booking.status === 'order_canceled'"
        >
          {{ 'label.payment-status' | translate }}:
          <br/>
          <span>
            <b>{{
            'booking.default.status.' + booking.status
              | lowercase
              | translate
            }}</b>
          </span>
        </div>
        <div 
          *ngIf="booking.deleted"
          class="border-start border-5 border-danger ps-2" 
        >
          {{ 'label.payment-status' | translate }}:
          <br/>
          <span
          ><b>{{
            'booking.default.status.deleted'
              | lowercase
              | translate
            }}</b></span
          >
          <hr class="my-1">
          {{ 'label.payment-status-before-deletion' | translate }}:
          <br/>
          <span
          ><b>{{
            'booking.default.status.' + booking.status
              | lowercase
              | translate
            }}</b></span
          >
        </div>
    </div>
    <div class="col-4 d-flex justify-content-center align-items-center">
      <img
        *ngIf="booking.test?.logoPath"
        [src]="booking.test.logoPath"
        [alt]="booking.test.name"
      />
    </div>
  </div>
</a>